import {
  PromotionModule,
  PromotionBrandModule,
  PromotionContentModule,
  PromotionHtmlWideModule,
  PromotionImageVideoModule,
  PromotionKeyVisualModule,
  PromotionPaymentBenefitModule,
  PromotionProductModule,
  PromotionRankingModule,
  PromotionShortFormModule,
  PromotionSpecialPriceModule,
  PromotionFirstPurchaseModule,
  PromotionWLiveModule,
  PromotionBasicNavigationModule,
  PromotionCommonNavigationModule,
  PromotionCouponModule,
  PromotionAdvertisementModule,
  PromotionProductListModule,
  PromotionFcfsCouponModule,
  PromotionHighlightPickModule,
  PromotionBrandCollectionModule,
  PromotionEntryModule,
  PromotionMainBannerModule,
  PromotionQuickBannerModule,
  PromotionTopBuyerModule,
} from '@wconcept/wconcept-common/models/renewal/promotion';

/**
 * 프로모션 모듈 타입 가드 함수들
 * 각 모듈 타입에 대한 타입 안전성을 보장합니다.
 */

export const isHtmlModule = (
  module: PromotionModule
): module is PromotionHtmlWideModule => module.moduleType === 'HTML_WIDE';

export const isKeyVisualModule = (
  module: PromotionModule
): module is PromotionKeyVisualModule => module.moduleType === 'KEY_VISUAL';

export const isMediaModule = (
  module: PromotionModule
): module is PromotionImageVideoModule => module.moduleType === 'IMAGE_VIDEO';

export const isLiveModule = (
  module: PromotionModule
): module is PromotionWLiveModule => module.moduleType === 'W_LIVE';

export const isSpecialPriceModule = (
  module: PromotionModule
): module is PromotionSpecialPriceModule =>
  module.moduleType === 'SPECIAL_PRICE';

export const isFirstPurchaseModule = (
  module: PromotionModule
): module is PromotionFirstPurchaseModule =>
  module.moduleType === 'FIRST_PURCHASE';

export const isRankingModule = (
  module: PromotionModule
): module is PromotionRankingModule => module.moduleType === 'RANKING';

export const isBrandModule = (
  module: PromotionModule
): module is PromotionBrandModule => module.moduleType === 'BRAND';

export const isBenefitsModule = (
  module: PromotionModule
): module is PromotionPaymentBenefitModule =>
  module.moduleType === 'PAYMENT_BENEFIT';

export const isStyleClipsModule = (
  module: PromotionModule
): module is PromotionShortFormModule => module.moduleType === 'SHORT_FORM';

export const isProductModule = (
  module: PromotionModule
): module is PromotionProductModule => module.moduleType === 'PRODUCT';

export const isContentModule = (
  module: PromotionModule
): module is PromotionContentModule => module.moduleType === 'CONTENT';

export const isBasicNavigationModule = (
  module: PromotionModule
): module is PromotionBasicNavigationModule =>
  module.moduleType === 'BASIC_NAVIGATION';

export const isCommonNavigationModule = (
  module: PromotionModule
): module is PromotionCommonNavigationModule =>
  module.moduleType === 'COMMON_NAVIGATION';

export const isCouponModule = (
  module: PromotionModule
): module is PromotionCouponModule => module.moduleType === 'COUPON';

export const isFcfsCouponModule = (
  module: PromotionModule
): module is PromotionFcfsCouponModule => module.moduleType === 'FCFS_COUPON';

export const isAdvertisementModule = (
  module: PromotionModule
): module is PromotionAdvertisementModule =>
  module.moduleType === 'ADVERTISEMENT';

export const isProductListModule = (
  module: PromotionModule
): module is PromotionProductListModule => module.moduleType === 'PRODUCT_LIST';

export const isHighlightPickModule = (
  module: PromotionModule
): module is PromotionHighlightPickModule =>
  module.moduleType === 'HIGHLIGHT_PICK';

export const isBrandCollectionModule = (
  module: any
): module is PromotionBrandCollectionModule =>
  module?.moduleType === 'BRAND_COLLECTION';
export const isEntryModule = (
  module: PromotionModule
): module is PromotionEntryModule => module.moduleType === 'ENTRY';

export const isMainBannerModule = (
  module: PromotionModule
): module is PromotionMainBannerModule => module.moduleType === 'MAIN_BANNER';

export const isQuickBannerModule = (
  module: PromotionModule
): module is PromotionQuickBannerModule => module.moduleType === 'QUICK_BANNER';

export const isTopBuyerModule = (
  module: PromotionModule
): module is PromotionTopBuyerModule => module.moduleType === 'TOP_BUYER';
/**
 * 지원되는 모듈 타입인지 확인하는 함수
 */
export const isValidModuleType = (moduleType: string): boolean => {
  const supportedTypes = [
    'HTML_WIDE',
    'IMAGE_VIDEO',
    'KEY_VISUAL',
    'W_LIVE',
    'SPECIAL_PRICE',
    'FIRST_PURCHASE',
    'RANKING',
    'BRAND',
    'PAYMENT_BENEFIT',
    'PRODUCT',
    'SHORT_FORM',
    'CONTENT',
    'BASIC_NAVIGATION',
    'COMMON_NAVIGATION',
    'COUPON',
    'ADVERTISEMENT',
    'PRODUCT_LIST',
    'FCFS_COUPON',
    'HIGHLIGHT_PICK',
    'BRAND_COLLECTION',
    'ENTRY',
    'MAIN_BANNER',
    'QUICK_BANNER',
  ];

  return supportedTypes.includes(moduleType);
};
